import {DataObject} from './DataObject';

export class CarrierServiceMap implements DataObject {
  ID: number;
  org_ID: number;
  map_Id: number;
  customerCarrierService: string;
  carrierService: string;

  constructor(obj: any) {
    this.ID = 0;
    this.org_ID = 0;
    this.map_Id = 0;
    this.customerCarrierService = '';
    this.carrierService = '';

    if (obj && obj['ID']) {
      this.ID = obj['ID'];
    }
    this.update(obj);
  }

  getId() {
    return this.ID;
  }

  getOrderValue() {
    return this.ID;
  }

  update(obj: any) {
    if (obj) {
      for (const prop of Object.keys(obj)) {
        if (obj[prop] !== null && (prop !== 'ID') && (typeof obj[prop] === 'string' || typeof obj[prop] === 'number' || typeof obj[prop] === 'boolean' || obj[prop] instanceof String || obj[prop] instanceof Boolean || obj[prop] instanceof Number || obj[prop] instanceof Date)) {
          this[prop] = obj[prop];
        }
      }
    }
  }
}

